import createRoute from '@widesk-ui/tools/createRoute';

export default createRoute.table('/entertainments/:entertainmentId/product_sales', 'shop', 'ProductSaleTable', 'Suivi des ventes - produits');
